import { render, staticRenderFns } from "./EditQuestionComponent.vue?vue&type=template&id=0b25ae69&"
import script from "./EditQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./EditQuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditQuestionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports